var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEmail24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.003,
    height: 15,
    viewBox: "0 0 18.003 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_email24x24",
    transform: "translate(-2.999 -4.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(2.999 4.998)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M32.785,330.383a1.381,1.381,0,0,0,1.053-.5l-5.1-6.36-.353.317q-.572.526-.929.82a5.4,5.4,0,0,1-.949.6,2.422,2.422,0,0,1-1.105.307h-.02a2.422,2.422,0,0,1-1.1-.307,5.386,5.386,0,0,1-.949-.6q-.357-.294-.929-.82l-.352-.318-5.1,6.36a1.382,1.382,0,0,0,1.053.5Z",
    transform: "translate(-16.392 -315.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1.015,199.582A5.676,5.676,0,0,1,0,198.555v9.114l4.495-5.28Q3.146,201.284,1.015,199.582Z",
    transform: "translate(.001 -194.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M416.8,199.582q-2.052,1.632-3.489,2.81l4.493,5.278v-9.114a5.924,5.924,0,0,1-1,1.027Z",
    transform: "translate(-399.801 -194.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M16.4,59.013H1.613a1.434,1.434,0,0,0-1.19.522,2.027,2.027,0,0,0-.417,1.306,2.347,2.347,0,0,0,.552,1.371,4.983,4.983,0,0,0,1.175,1.16q.341.241,2.059,1.431c.618.428,1.156.8,1.618,1.124.394.274.733.512,1.014.709l.15.107.277.2q.326.236.542.382t.522.326a3.048,3.048,0,0,0,.578.271,1.6,1.6,0,0,0,.5.09h.02a1.6,1.6,0,0,0,.5-.09,3.041,3.041,0,0,0,.578-.271q.306-.181.522-.326t.542-.382l.277-.2.15-.107L12.6,65.93l3.684-2.558a4.777,4.777,0,0,0,1.225-1.235A2.657,2.657,0,0,0,18,60.62a1.62,1.62,0,0,0-1.6-1.607Z",
    transform: "translate(-.005 -59.011)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEmail24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_email24x24.0820256c90179415d7523b7d7ab0751d.svg";